module.exports = __webpack_public_path__ + "img/light-switch.ad60d49f.svg";